export const painPoints = [
  'Tu swing largo arruina tus golpes y la pelota termina siempre en el blindex o en la red.',
  "Buscás el 'winner' constantemente y terminás perdiendo puntos que tenías controlados.",
  'Te quedás en el fondo de la cancha por comodidad o le tenés miedo a subir a la red.',
  'Las paredes son un misterio: no sabés leer el rebote, te anticipás mal y perdés la posición.',
  'Te cuesta coordinar con tu pareja y jugás como si fuera un deporte individual.',
  'Sentís frustración porque tu técnica impecable de tenis no se traduce en victorias en la cancha de pádel.',
]

export const modules = [
  {
    title: '🧠 MÓDULO 1 — Por qué el tenis te juega en contra',
    content: [
      {
        subtitle:
          '1.1 Los 5 vicios del tenista que aparecen en la cancha de pádel',
        items: [
          'El backswing largo: por qué funciona en tenis y destruye en pádel',
          'La búsqueda del winner: el error mental más caro',
          'Pararse lejos de la pared por miedo al rebote',
          'Subir a la red como si fuera saque y volea',
          'Mirar la pelota en lugar de leer la cancha',
        ],
      },
      {
        subtitle:
          '1.2 Por qué tu swing te hace perder puntos en lugar de ganarlos',
        items: [
          'Qué es el swing en tenis y para qué sirve',
          'Por qué el pádel no necesita ni tolera ese movimiento',
          'Lo que pasa en el punto cuando swingás de más',
          'El momento exacto en que el tenista pierde el control del golpe',
        ],
      },
      {
        subtitle:
          '1.3 La trampa del golpe ganador: mentalidad de tenis vs mentalidad de pádel',
        items: [
          'En tenis ganás puntos, en pádel los construís',
          'Qué significa construir un punto y cómo se hace',
          'Por qué el tenista apura y cómo frenarlo',
          'El cambio de chip que separa al tenista que aprende del que se frustra',
        ],
      },
      {
        subtitle:
          '1.4 Cómo el cerebro automatiza lo que aprendiste y cómo reprogramarlo',
        items: [
          'Qué es la memoria motriz y por qué es tan difícil de borrar',
          'Cuántas repeticiones necesita el cerebro para reemplazar un patrón',
          'Por qué jugar partidos seguidos te hace retroceder al principio',
          'El método de corrección que usan los entrenadores de élite',
        ],
      },
      {
        subtitle:
          '1.5 Test de diagnóstico: ¿cuánto tenis todavía tenés en el cuerpo?',
        items: [
          '20 preguntas de autoevaluación técnica y táctica',
          'Cómo interpretar tu puntaje',
          'Qué módulo priorizar según tu resultado',
          'Punto de partida personalizado para las 8 semanas',
        ],
      },
    ],
  },
  {
    title:
      '🎾 MÓDULO 2 — Técnica: lo que cambia, lo que sirve y lo que hay que borrar',
    content: [
      {
        subtitle:
          '2.1 El grip: por qué el continental del tenis te arruina el pádel',
        items: [
          'Qué es el grip continental y por qué domina en tenis',
          'El grip de pádel: continental modificado y sus variantes',
          'Cómo cambiarlo sin perder potencia ni control',
          'Ejercicio de grip: 15 minutos que cambian todo',
        ],
      },
      {
        subtitle: '2.2 El swing corto: cómo acortarlo sin perder potencia',
        items: [
          'La diferencia entre swing corto y golpe débil',
          'Dónde viene la potencia en pádel si no es del swing',
          'Drill de pared para entrenar el swing corto solo',
          'Los 3 errores más comunes al intentar acortarlo',
        ],
      },
      {
        subtitle:
          '2.3 La volea de tenis vs el bloqueo de pádel: son movimientos opuestos',
        items: [
          'La volea de tenis: punch hacia adelante con swing',
          'El bloqueo de pádel: absorber, redirigir, controlar',
          'Por qué el tenista manda la volea larga o a la red',
          'Ejercicio de bloqueo contra pared de fondo',
        ],
      },
      {
        subtitle:
          '2.4 El revés: lo único que el tenis te da gratis en el pádel',
        items: [
          'Por qué el revés es el golpe que mejor transfiere',
          'Las diferencias que igual existen y hay que ajustar',
          'Cómo aprovecharlo desde el primer día en cancha',
          'Cuándo el revés del tenista se convierte en problema',
        ],
      },
      {
        subtitle:
          '2.5 La bandeja: el golpe que el tenista aprende más rápido y por qué',
        items: [
          'Qué es la bandeja y cuándo se usa',
          'La conexión con el slice de tenis: misma lógica, otro contexto',
          'Los errores típicos del tenista en la bandeja',
          'Progresión de aprendizaje en 3 pasos',
        ],
      },
      {
        subtitle:
          '2.6 La víbora: cuándo intentarla y cuándo es un error de ego',
        items: [
          'Qué es la víbora y para qué sirve tácticamente',
          'Por qué el tenista la quiere aprender antes que nada',
          'En qué nivel de juego tiene sentido incorporarla',
          'Qué pasa cuando la intentás antes de tiempo',
        ],
      },
      {
        subtitle:
          '2.7 El remate: la diferencia entre el smash de tenis y el remate con pared',
        items: [
          'El smash de tenis: definición directa, sin pared',
          'El remate de pádel: por arriba, por dos paredes o bajada',
          'Por qué el tenista remata siempre por arriba y cuándo eso es un error',
          'Los 3 tipos de remate que hay que conocer',
        ],
      },
    ],
  },
  {
    title: '🧱 MÓDULO 3 — Las paredes: el elemento que no existe en tu cabeza',
    content: [
      {
        subtitle: '3.1 Cómo leer el rebote en pared de fondo',
        items: [
          'Cómo funciona físicamente el rebote en el cristal',
          'Variables que cambian el rebote: velocidad, altura, efecto',
          'Dónde pararse para recibir el rebote sin correr de más',
          'El error del tenista: esperar la pelota como si fuera un fondo de tenis',
        ],
      },
      {
        subtitle:
          '3.2 Pared lateral: el rebote que más errores le genera al tenista',
        items: [
          'Por qué la pared lateral es la más difícil de leer',
          'El ángulo de rebote y cómo anticiparlo',
          'Cuándo dejar pasar y cuándo intervenir antes de la pared',
          'Drill específico para la pared lateral en 10 minutos',
        ],
      },
      {
        subtitle: '3.3 Cuándo jugar antes de la pared y cuándo esperar',
        items: [
          'La regla general y sus excepciones',
          'Señales visuales que te dicen qué hacer antes de que llegue la pelota',
          'El error más caro: dudar en el momento de decidir',
          'Situaciones de partido donde esta decisión define el punto',
        ],
      },
      {
        subtitle:
          '3.4 El error más común: tratar la pared como el fondo de la cancha de tenis',
        items: [
          'Por qué el cerebro del tenista hace esa asociación',
          'Qué pasa técnica y tácticamente cuando cometés ese error',
          'Cómo reprogramar la lectura de pared de fondo',
          'Un ejercicio de visualización antes de entrar a la cancha',
        ],
      },
      {
        subtitle:
          '3.5 Ejercicios para incorporar la pared en menos de 4 sesiones',
        items: [
          'Sesión 1: solo con pared de fondo, sin presión de punto',
          'Sesión 2: pared lateral, lectura y posición',
          'Sesión 3: situaciones reales de partido con foco en pared',
          'Sesión 4: juego libre con autoevaluación de lectura de pared',
        ],
      },
    ],
  },
  {
    title: '🧩 MÓDULO 4 — Táctica desde cero para el tenista',
    content: [
      {
        subtitle: '4.1 Por qué en pádel se gana en la red y no desde el fondo',
        items: [
          'La lógica geométrica de la red en pádel',
          'Por qué el fondo es una posición defensiva, no neutral',
          'Qué le pasa al tenista que se queda en el fondo toda la vida',
          'Cómo cambiar el objetivo del punto desde el primer golpe',
        ],
      },
      {
        subtitle: '4.2 Cómo subir a la red sin que te pasen por arriba',
        items: [
          'Cuándo es el momento correcto para subir',
          'Cómo subir: trayectoria, velocidad y posición de llegada',
          'Qué hacer cuando el rival te tira el globo',
          'El error del tenista: subir en el momento equivocado',
        ],
      },
      {
        subtitle:
          '4.3 La lógica del punto en pádel: construcción vs definición',
        items: [
          'Qué es un punto de construcción y cómo se juega',
          'Qué es un punto de definición y cuándo llega',
          'Por qué el tenista quiere definir siempre y eso lo perjudica',
          'Ejemplos de secuencias tácticas reales',
        ],
      },
      {
        subtitle:
          '4.4 Dónde pararse: los errores de posición que delatan al tenista',
        items: [
          'La posición base en pádel vs la posición base en tenis',
          'Los 4 errores de posición más comunes del tenista',
          'Cómo leer la posición del rival para ajustar la propia',
          'Ejercicio de posición sin pelota: el shadow positioning',
        ],
      },
      {
        subtitle:
          '4.5 Jugar con un compañero nuevo: cómo comunicarse y organizarse',
        items: [
          'Qué información mínima necesitás antes de entrar a la cancha',
          'Cómo dividir la cancha sin entrar en conflicto',
          'Señales básicas de comunicación durante el punto',
          'Qué hacer cuando el compañero juega distinto a lo que esperabas',
        ],
      },
    ],
  },
  {
    title: '👥 MÓDULO 5 — El doble: dinámica de pareja para el ex tenista',
    content: [
      {
        subtitle: '5.1 El pádel es un deporte de parejas, no de individuos',
        items: [
          'Por qué el individualismo del tenista es su mayor obstáculo',
          'La diferencia entre jugar junto a alguien y jugar con alguien',
          'Cómo medir si estás jugando en equipo o en paralelo',
          'El cambio de mentalidad que más rápido mejora tu juego',
        ],
      },
      {
        subtitle: '5.2 Cómo coordinarte con tu compañero sin hablar de más',
        items: [
          'Qué comunicar y qué no comunicar durante el punto',
          'Las señales no verbales que todo jugador de pádel usa',
          'Cómo generar un lenguaje común con cualquier compañero',
          'Los momentos clave donde la comunicación define el punto',
        ],
      },
      {
        subtitle: '5.3 Rotaciones básicas: cuándo cruzar y cuándo quedarse',
        items: [
          'Qué es una rotación y por qué existe en pádel',
          'La regla del cruce: cuándo sí y cuándo no',
          'Los errores de rotación más comunes en parejas nuevas',
          'Drill de rotaciones sin presión de punto',
        ],
      },
      {
        subtitle: '5.4 Qué hacer cuando tu compañero es mejor (o peor) que vos',
        items: [
          'Jugar con alguien mejor: cómo no ser un lastre',
          'Jugar con alguien peor: cómo sostener sin sobrecargar',
          'Cómo ajustar tu juego sin cambiar tu rol en la cancha',
          'Por qué la humildad táctica es una habilidad, no una actitud',
        ],
      },
      {
        subtitle:
          '5.5 Los errores de comunicación que rompen parejas en cancha',
        items: [
          'El silencio total: cuando nadie dice nada y todo sale mal',
          'El exceso de indicaciones: cuando uno dirige y el otro se bloquea',
          'La culpa después del error: cómo no destruir la confianza',
          'Protocolo de pausa: qué decirse entre punto y punto',
        ],
      },
    ],
  },
  {
    title: '📅 MÓDULO 6 — Plan de transición de 8 semanas',
    content: [
      {
        subtitle: '6.1 Semana 1–2: diagnóstico y corrección de grip y swing',
        items: [
          'Objetivos de las dos primeras semanas',
          'Rutina de entrenamiento diaria (con y sin cancha)',
          'Qué medir y cómo registrarlo',
          'Señales de que estás avanzando bien',
        ],
      },
      {
        subtitle: '6.2 Semana 3–4: incorporación de paredes en juego real',
        items: [
          'Objetivos del segundo bloque',
          'Ejercicios específicos de pared para esta fase',
          'Cómo integrar la pared en puntos reales sin perder el foco técnico',
          'Errores esperables en esta etapa y cómo manejarlos',
        ],
      },
      {
        subtitle: '6.3 Semana 5–6: trabajo táctico en red',
        items: [
          'Objetivos del tercer bloque',
          'Drills de subida a la red y posicionamiento',
          'Cómo medir tu mejora táctica semana a semana',
          'Señales de que ya podés jugar con más libertad',
        ],
      },
      {
        subtitle: '6.4 Semana 7–8: juego completo con foco en automatización',
        items: [
          'Objetivos del bloque final',
          'Cómo jugar partidos reales sin volver a los vicios del tenis',
          'La checklist pre-partido para activar la mentalidad de pádel',
          'Cómo saber si completaste la transición',
        ],
      },
      {
        subtitle: '6.5 Cómo autoevaluarte al final del plan',
        items: [
          'Los 5 indicadores de que ya jugás como jugador de pádel',
          'Qué hacer si todavía sentís vicios del tenis después de 8 semanas',
          'Adónde ir desde acá: próximos pasos para seguir mejorando',
        ],
      },
    ],
  },
]

export const bonuses = [
  {
    title: 'BONUS 1 — 🗓️ Planilla de las 8 semanas',
    image:
      'https://cdn.magicpatterns.com/uploads/ctiXuw1qEBiaNHTCxPPvtt/Bono_1.png',
    content: `Planilla de Transición — 8 Semanas de Pádel

Hoja 1 — Panel de control
• Nombre del jugador
• Fecha de inicio del plan
• Nivel de tenis previo (principiante / intermedio / avanzado)
• Objetivo principal de la transición
• Barra de progreso general (calculada automáticamente)

Hoja 2 — Semanas 1 y 2: Grip y Swing
• Día / Tipo de sesión (cancha / sin cancha / mental)
• Ejercicio del día (desplegable con los ejercicios del Módulo 2)
• Duración en minutos
• Checkbox de completado
• Campo: ¿qué vicio apareció hoy?
• Campo: ¿qué mejoró respecto a ayer?
• Autoevaluación del día: 1 a 5

Hoja 3 — Semanas 3 y 4: Paredes
Igual estructura + columna específica:
• Tipo de pared trabajada (fondo / lateral / combinada)
• Lectura del rebote: ¿anticipé o reaccioné?
• Error más repetido de la sesión

Hoja 4 — Semanas 5 y 6: Red y Táctica
Igual estructura + columnas:
• ¿Subí a la red en el momento correcto? (Sí / No / A veces)
• Situación táctica más difícil de la sesión
• ¿Construí puntos o busqué el winner?

Hoja 5 — Semanas 7 y 8: Automatización
Igual estructura + columnas:
• Vicios del tenis que aparecieron (lista desplegable)
• Nivel de automatización percibido: 1 a 10
• ¿Necesité pensar el golpe o salió solo?

Hoja 6 — Autoevaluación final
• Los 5 indicadores del ebook con escala 1–10
• Gráfico de progreso semana a semana (automático)
• Campo de reflexión libre: ¿qué cambió en tu juego?
• Recomendación automática según puntaje final`,
  },
  {
    title: 'BONUS 2 — ✅ Checklist del tenista',
    image:
      'https://cdn.magicpatterns.com/uploads/9cYhG65RsdC9LSsKuh8vNR/Bono_2.png',
    content: `Checklist Pre-Partido — ¿Estás jugando pádel o tenis?

Bloque 1 — Antes de entrar a la cancha (5 ítems)
☐ Revisé mi grip (no continental puro)
☐ Tengo en mente que voy a construir, no a ganar con un golpe
☐ Sé dónde está mi posición base
☐ Acordé con mi compañero cómo vamos a cubrir la cancha
☐ Estoy dispuesto a subir a la red en el momento correcto

Bloque 2 — Durante el calentamiento (5 ítems)
☐ Acorté el swing desde el primer golpe
☐ Practiqué al menos 3 rebotes en pared de fondo
☐ Bloqueé las voleas en lugar de punchearlas
☐ Me posicioné cerca de la red en al menos una subida
☐ Observé cómo rebota la pared lateral de esta cancha

Bloque 3 — Durante el partido (5 ítems)
☐ Estoy esperando el rebote en lugar de anticipar como en tenis
☐ No busqué el winner antes de construir el punto
☐ Me comuniqué con mi compañero entre puntos
☐ Subí a la red cuando tuve la oportunidad
☐ No me quedé en el fondo por comodidad

Bloque 4 — Al terminar (3 ítems)
☐ Identifiqué el vicio del tenis que más apareció hoy
☐ Tengo claro qué voy a trabajar en la próxima sesión
☐ Registré la sesión en la planilla de 8 semanas`,
  },
  {
    title: 'BONUS 3 — 📖 Glosario tenis → pádel',
    image:
      'https://cdn.magicpatterns.com/uploads/kfhEh8SMqzFy7vTbx1wDR2/Bono_3.png',
    isTable: true,
    tables: [
      {
        title: 'Sección 1 — Golpes: mismo nombre, distinto movimiento',
        headers: ['Término en tenis', 'Cómo se usa en pádel', 'Qué cambia'],
        rows: [
          ['Volea', 'Bloqueo / volea de control', 'No hay punch, se absorbe'],
          ['Smash', 'Remate (por arriba / por dos)', 'Puede ir con pared'],
          ['Slice', 'Base del golpe defensivo', 'Se usa mucho más'],
          ['Drive', 'Drive de pádel', 'Swing mucho más corto'],
          ['Lob', 'Globo', 'Herramienta táctica central'],
        ],
      },
      {
        title: 'Sección 2 — Golpes que no existen en tenis',
        headers: ['Golpe de pádel', 'Qué es', 'Cuándo se usa'],
        rows: [
          [
            'Bandeja',
            'Golpe sobre la cabeza con efecto cortado',
            'Para defender globos sin definir',
          ],
          [
            'Víbora',
            'Drive por encima del hombro con efecto',
            'Para atacar desde posición ofensiva',
          ],
          [
            'Bajada de pared',
            'Golpe tras rebote en pared de fondo',
            'Cuando la pelota viene lenta y alta',
          ],
          [
            'Remate por dos',
            'Smash que usa dos paredes antes de salir',
            'Para definir desde el fondo',
          ],
          [
            'Chiquita',
            'Golpe suave y cruzado al cristal frontal',
            'Para ganar la red o sacar al rival',
          ],
        ],
      },
      {
        title: 'Sección 3 — Conceptos tácticos que cambian',
        headers: [
          'Concepto en tenis',
          'Equivalente en pádel',
          'La diferencia clave',
        ],
        rows: [
          [
            'Ganar desde el fondo',
            'No existe como estrategia',
            'El fondo es posición defensiva',
          ],
          ['Winner', 'Punto construido', 'Se define después de varios golpes'],
          [
            'Saque y volea',
            'Subida a la red táctica',
            'Se sube en cualquier momento del punto',
          ],
          ['Break', 'No aplica', 'El servicio no da ventaja estructural'],
          [
            'Passing shot',
            'Globo ofensivo',
            'La respuesta al rival en red es el globo',
          ],
        ],
      },
      {
        title: 'Sección 4 — Posiciones en cancha',
        headers: ['En tenis', 'En pádel', 'Diferencia'],
        rows: [
          [
            'Fondo de cancha',
            'Posición defensiva',
            'No es neutral, es desventaja',
          ],
          ['Media cancha', 'Zona de transición', 'Hay que evitarla'],
          ['Red', 'Posición dominante', 'El objetivo de cada punto'],
          [
            'Lado de revés',
            'Lado izquierdo (para diestros)',
            'Suele jugar el jugador más sólido',
          ],
        ],
      },
    ],
  },
  {
    title: 'BONUS 4 — 🎾 Los 7 golpes que el tenista ejecuta mal en pádel',
    image:
      'https://cdn.magicpatterns.com/uploads/a9yQdb9MhtrfCsE8aoQZRZ/Bono_4.png',
    content: `Los 7 Golpes — Diagnóstico, causa y corrección para el tenista

Introducción: Por qué estos 7 golpes concentran el 80% de los errores del tenista en su primer año de pádel.

Golpe 1 — La volea
• Diagnóstico: ¿cómo la ejecuta mal el tenista?
• Causa: el automatismo del punch y la búsqueda de profundidad
• Corrección: el bloqueo activo — cómo practicarlo en 10 minutos
• Ejercicio específico: volea de control contra pared de fondo

Golpe 2 — El drive (o golpe de fondo)
• Diagnóstico: swing largo, pelota larga o en la red
• Causa: búsqueda de potencia como en tenis
• Corrección: acortar el backswing manteniendo la aceleración de muñeca
• Ejercicio específico: drive corto en zona de servicio

Golpe 3 — El globo
• Diagnóstico: globo corto que el rival remata, o globo largo que sale
• Causa: en tenis el lob es excepcional, en pádel es estructural
• Corrección: cambiar la lógica del globo — no es defensa, es táctica
• Ejercicio específico: globo cruzado desde el fondo

Golpe 4 — El remate
• Diagnóstico: el tenista remata siempre por arriba sin leer la pared
• Causa: en tenis el smash siempre es directo
• Corrección: aprender los 3 tipos de remate y cuándo usar cada uno
• Ejercicio específico: remate por dos paredes desde posición de red

Golpe 5 — La bandeja
• Diagnóstico: la ejecuta con demasiada potencia o con swing de tenis
• Causa: confunde la bandeja con un smash suavizado
• Corrección: entender que la bandeja es control, no potencia
• Ejercicio específico: bandeja cruzada con objetivo de zona

Golpe 6 — La bajada de pared
• Diagnóstico: no la intenta, o la intenta y manda la pelota a la red
• Causa: no existe en tenis, el cerebro no tiene referencia
• Corrección: la lectura del rebote lento y la posición de espera
• Ejercicio específico: bajada de pared solo con pelota muerta

Golpe 7 — El bloqueo al cuerpo
• Diagnóstico: el tenista se aparta o intenta una volea ofensiva
• Causa: en tenis el golpe al cuerpo se esquiva o se ataca
• Corrección: el bloqueo neutro — ni atacar ni esquivar
• Ejercicio específico: bloqueo al cuerpo con compañero a 2 metros`,
  },
  {
    title: 'BONUS 5 — 🧠 Mini guía táctica de los primeros 10 puntos',
    image:
      'https://cdn.magicpatterns.com/uploads/qwW7T17kS22whuLTtMiuuX/Bono_5_Items.png',
    content: `Los Primeros 10 Puntos — Protocolo de partido para el tenista que empieza

Introducción: Por qué los primeros 10 puntos de un partido definen el tono de todo lo que viene. El tenista que no tiene protocolo vuelve al piloto automático del tenis en los primeros 3 puntos.

Parte 1 — El protocolo punto por punto

Situación 1 — Estoy sacando
• Qué hacer con el primer saque
• Dónde posicionarme después del saque
• Qué espero que haga el rival y cómo respondo

Situación 2 — Estoy restando
• Cómo leer el saque de pádel (no es como en tenis)
• Qué respuesta dar según la altura y velocidad del saque
• Cómo organizarme con mi compañero en el resto

Situación 3 — Tengo la red
• Qué hacer cuando ya llegué a la red
• Cómo responder al globo sin perder posición
• Cuándo cruzar y cuándo quedarme

Situación 4 — El rival tiene la red
• La primera opción siempre es el globo
• Cuándo intentar el passing y cuándo es un error
• Cómo recuperar la red desde el fondo

Situación 5 — Estoy en el fondo y la pelota viene de la pared
• Leer el rebote antes de decidir
• Tres opciones posibles y cuándo elegir cada una
• Lo que el tenista hace mal en esta situación

Parte 2 — El mapa mental pre-partido
Qué preguntarse antes de cada punto para no entrar en piloto automático

Parte 3 — Checklist de activación táctica
• 5 preguntas que hacerse antes de entrar a la cancha
• La frase de anclaje para recordar la mentalidad de pádel durante el partido.`,
  },
]

export const bonusCards = [
  {
    emoji: '🗓️',
    label: 'BONUS 1',
    title: 'Planilla de Transición — 8 Semanas',
    meta: 'Google Sheets · Incluido en tu descarga',
    description:
      'Seguí tu progreso semana a semana con objetivos claros, registro de sesiones y autoevaluación automática. Sabés exactamente en qué estás, qué mejoró y qué falta trabajar.',
    chips: [
      '📊 Gráfico de progreso automático',
      '✅ Registro diario de sesiones',
      '🎯 Autoevaluación final',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/ctiXuw1qEBiaNHTCxPPvtt/Bono_1.png',
  },
  {
    emoji: '✅',
    label: 'BONUS 2',
    title: 'Checklist Pre-Partido del Tenista',
    meta: 'PDF · 1 página · Para llevar en el teléfono',
    description:
      'Antes de entrar a la cancha, revisás los 18 puntos clave que separan al tenista del jugador de pádel. En 2 minutos sabés si tu cabeza y tu cuerpo están listos para jugar pádel de verdad.',
    chips: [
      '📱 Diseñado para el teléfono',
      '⚡ Lectura de 2 minutos',
      '🔄 Reutilizable en cada partido',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/9cYhG65RsdC9LSsKuh8vNR/Bono_2.png',
  },
  {
    emoji: '📖',
    label: 'BONUS 3',
    title: 'Glosario Tenis → Pádel',
    meta: 'PDF · 3 páginas · La traducción que nadie te dio',
    description:
      'Todo lo que cambia de un deporte al otro: golpes con el mismo nombre pero distinto movimiento, golpes que no existen en tenis y conceptos tácticos que funcionan al revés. La referencia rápida que deberías haber tenido desde el primer día.',
    chips: [
      '🔄 Golpes que cambian',
      '🆕 Golpes nuevos',
      '🧩 Conceptos tácticos',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/kfhEh8SMqzFy7vTbx1wDR2/Bono_3.png',
  },
  {
    emoji: '🎾',
    label: 'BONUS 4',
    title: 'Los 7 Golpes que el Tenista Ejecuta Mal',
    meta: 'PDF · 12 páginas · El diagnóstico que ningún video te da',
    description:
      'Volea, drive, globo, remate, bandeja, bajada de pared y bloqueo al cuerpo. Para cada uno: qué hacés mal, por qué lo hacés y el ejercicio exacto para corregirlo. El documento al que vas a volver cada vez que un golpe no te sale.',
    chips: [
      '🔍 Diagnóstico por golpe',
      '💡 Causa del error',
      '🏋️ Ejercicio de corrección',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/a9yQdb9MhtrfCsE8aoQZRZ/Bono_4.png',
  },
  {
    emoji: '🧠',
    label: 'BONUS 5',
    title: 'Mini Guía Táctica de los Primeros 10 Puntos',
    meta: 'PDF · 6 páginas · Tu protocolo de partido',
    description:
      'Las 5 situaciones más frecuentes de los primeros puntos — saque, resto, red, fondo, pared — con la respuesta correcta para cada una. Leéla antes de entrar a la cancha y dejá de improvisar con los automatismos del tenis.',
    chips: [
      '⚡ 5 situaciones clave',
      '🗺️ Mapa mental de decisiones',
      '🎯 Checklist de activación táctica',
    ],
    image:
      'https://cdn.magicpatterns.com/uploads/qwW7T17kS22whuLTtMiuuX/Bono_5_Items.png',
  },
]

export const testimonials = [
  {
    name: 'Martín, 42 años',
    city: 'Rosario',
    text: 'Jugaba al tenis desde chico. En el pádel me frustraba porque le pegaba fuerte pero perdía con tipos que la pasaban nomás. Este libro me cambió el chip. Ahora entiendo las paredes y armo los puntos.',
  },
  {
    name: 'Diego, 35 años',
    city: 'Córdoba',
    text: 'El módulo de los vicios del tenista me describió a la perfección. Acorté el swing y dejé de buscar el winner todo el tiempo. Subí de categoría en dos meses.',
  },
  {
    name: 'Laura, 38 años',
    city: 'CABA',
    text: 'Me costaba mucho la volea, la hacía como en tenis y se me iba larga. El tip del bloqueo me salvó. Muy buena guía, súper práctica.',
  },
  {
    name: 'Alejandro, 50 años',
    city: 'Mendoza',
    text: 'Excelente material. La planilla de 8 semanas me ayudó a enfocarme en un problema a la vez. Ya no le tengo miedo a la pared lateral.',
  },
  {
    name: 'Javier, 45 años',
    city: 'La Plata',
    text: 'Vale cada peso. El glosario y la táctica de los primeros 10 puntos son oro puro. Dejé de jugar al tenis en una cancha de pádel.',
  },
]

export const objections = [
  {
    q: '¿No tengo tiempo para leer un libro largo?',
    a: 'Es una guía práctica y directa al grano. Diseñada para leer rápido y aplicar en la cancha el mismo día.',
  },
  {
    q: '¿Ya juego hace años, me sirve?',
    a: 'Si seguís sintiendo que tu técnica de tenis te limita (problemas con paredes, bandejas, táctica), este libro te va a destrabar sin importar cuánto hace que jugás.',
  },
  {
    q: '¿Es muy caro?',
    a: 'Cuesta menos que un turno de cancha o una clase particular, y te da herramientas que te van a servir para toda la vida.',
  },
  {
    q: '¿Soy principiante en pádel, lo voy a entender?',
    a: 'Absolutamente. Es ideal para no incorporar vicios desde el principio y empezar con la técnica y táctica correctas.',
  },
  {
    q: '¿Funciona si soy mayor?',
    a: 'El pádel es un deporte muy táctico. Aprender a posicionarte y usar las paredes te va a hacer correr menos y ganar más, sin importar tu edad.',
  },
]
